module.exports = __webpack_public_path__ + "static/media/edit.68bacd9c.svg";